module.exports = __webpack_public_path__ + "img/icon-ketang-logo.d414091f.png";